import { Component, OnInit } from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ForumsService} from '../../service/forums.service';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { commonService } from '../../service/common.service';
import { NgxPermissionsService } from "ngx-permissions";
@Component({
  selector: 'app-trandingtopic',
  templateUrl: './trandingtopic.component.html',
  styleUrls: ['./trandingtopic.component.css'],
  providers:[ForumsService]
})
export class TrandingtopicComponent implements OnInit {
  msg="";
  trandingList=[];
  userData:any;
  progress:any;
  constructor(private forumsService: ForumsService,private router: Router,private route: ActivatedRoute,private commonService:commonService) { }

  ngOnInit() {

    this.commonService.profile.subscribe((data:any)=>{
      if(data && Object.keys(data).length != 0){
      this.userData=data; 
      this.progress=this.progressbar();
      }else{
       this.userData={};
      }
    });

    this.getTrandingTopic();
  }

  progressbar(){
     var progress:number=0;
       if(this.userData.photo!=""){
        progress++;
       }
       if(this.userData.intro!=""){
        progress++;
       }
       if(this.userData.workingAt!=""){
        progress++;
       }
       if(this.userData.education!=""){
        progress++;
       }
       if(this.userData.skills!=""){
        progress++;
       }
       return progress*20;
  }
  getTrandingTopic(){
    let obj={};
    obj['limit']=50;
    obj['offset']=0;
    this.forumsService.getTrandingTopic(obj).subscribe((data:any)=>{

      if(data.error==0){

        this.trandingList=data.result;
      //  console.log(this.trandingList);
      }
      

    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
    
  }
  posturl(post){
    this.router.navigate(['forum/'+post.id]);

  }

  datediff(date){
    return this.commonService.datediff(date);
   }

   

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/trandingtopic/trandingtopic.component.ts